import React from 'react';
import './presentationCard.css';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardActionArea from '@material-ui/core/CardActionArea';
import Typography from '@material-ui/core/Typography';
import { safeExternalUrl } from '../../utils/safeUrl';

class PresentationCard extends React.Component {
  render() {
    const { item } = this.props;
    const href = safeExternalUrl(item.url);
    return (
      <a href={href} target='_blank' rel='noopener noreferrer'>
        <Card className='presentation-card' flexWrap='nowrap' align='center'>
          <CardActionArea>
            <CardContent className='presentation-content'>
              <img className='cardImage' src={item.imageUrl} alt={item.title} />
              <Typography className='presentation-title'>{item.title}</Typography>
              <Typography className='presentation-description'>{item.description}</Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </a>
    );
  }
}

export default PresentationCard;
